export enum QUIZ_ANALYTIC_EVENTS {
  FLOW_START_OPEN = 'flow_start_open',
  FLOW_GENDER_OPEN = 'flow_gender_open',
  FLOW_NAME_OPEN = 'flow_name_open',
  FLOW_TESTIMONIAL1_OPEN = 'flow_testimonial1_open',
  FLOW_PARTNER_OPEN = 'flow_partner_open',
  FLOW_TESTIMONIAL2_OPEN = 'flow_testimonial2_open',
  FLOW_EMAILFORM_OPEN = 'flow_emailform_open',
}
